import React, { Component } from 'react'
import { CreditCardIcon } from '@heroicons/react/outline'

/*

Class : StripeRevenueCard
Description : Carte de la page Statistiques affichant le CA CB perçu par le
camping (montant total encaissé via Stripe − frais totaux) sur la période.
Rendue uniquement si le compte Stripe du camping est connecté (data.stripe).
Montants reçus en centimes.
Author : Franck David

*/

class StripeRevenueCard extends Component {
	_formatEuro = (cents) => {
		const value = (Number(cents) || 0) / 100
		let txt = value.toFixed(2).replace('.', ',')
		// retire les centimes inutiles (",00")
		if (txt.indexOf(',00') === txt.length - 3)
			txt = txt.substring(0, txt.length - 3)
		return txt + ' €'
	}

	render() {
		const stripe = this.props.stripe
		if (!stripe)
			return null
		const net = stripe.net || 0
		const amount = stripe.amount || 0
		const fees = stripe.fees || 0
		if (amount === 0)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-3">Paiements CB</h2>
					<div className="flex items-center gap-3">
						<div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
							<CreditCardIcon className="w-5 h-5 text-slate-400" aria-hidden="true" />
						</div>
						<p className="text-sm font-medium text-slate-500 my-0">Aucun paiement CB in-app sur la période.</p>
					</div>
				</div>
			)
		}
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
				<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-4">Paiements CB</h2>
				<div className="flex items-center gap-3">
					<div className="w-9 h-9 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0">
						<CreditCardIcon className="w-5 h-5 text-indigo-600" aria-hidden="true" />
					</div>
					<div>
						<p className="text-2xl font-black text-slate-900 my-0 leading-none">{this._formatEuro(net)}</p>
						<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest mt-1 mb-0">{this.props.periodLabel || 'TTC perçu par le camping'}</p>
					</div>
				</div>
				<div className="flex flex-wrap gap-x-6 gap-y-2 mt-4 pt-4 border-t border-slate-100">
					<div>
						<p className="text-sm font-black text-slate-900 my-0">{this._formatEuro(amount)}</p>
						<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Encaissé TTC</p>
					</div>
					<div>
						<p className="text-sm font-black text-slate-900 my-0">{this._formatEuro(fees)}</p>
						<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Frais totaux</p>
					</div>
				</div>
			</div>
		)
	}
}

export default StripeRevenueCard
